import { withContext } from '../Context'
import TestScoreSelectorWithSubjects, { Subject } from './TestScoreSelectorWithSubjects'

const SAT_SUBJECTS: Subject[] = [
  { name: 'SATMath', label: 'Math', min: 200, max: 800, rangeStep: 10 },
  { name: 'SATReadingWriting', label: 'Reading & Writing', min: 200, max: 800, rangeStep: 10 },
]

type SATScoreSelectorProps = {
  criteria: string
  onChange: (criteria: string, segmentName: string, value: any, operation: string) => void
  segment: object
  isSubjectTestsEnabled?: boolean
}

export const SATScoreSelector = (props: SATScoreSelectorProps) => {
  return (
    <TestScoreSelectorWithSubjects
      {...props}
      testLabel="SAT"
      totalScoreSegmentName="SAT"
      totalScoreMin={400}
      totalScoreMax={1600}
      totalScoreStep={10}
      subjects={SAT_SUBJECTS}
    />
  )
}

export default withContext(SATScoreSelector)
